import { useEffect, useState } from "react";

import ButtonDesign from "../ButtonDesign/ButtonDesign";

import "./ServiceCard.css";

const ServiceCard = ({ data, handleClick }) => {
	const [buttonMore, setButtonMore] = useState(false);
	useEffect(() => {
		if ("buttonMore" in data) {
			setButtonMore(data["buttonMore"]);
		}
	}, [data]);

	return (
		<div
			className="service-card"
			key={data["id"]}
			onClick={(e) => {
				if (handleClick) {
					handleClick();
				}
			}}
		>
			<div>
				<div className="service-card-icon">
					<img
						alt={data["alt"]}
						src={require("../../assets/" + data["icon"])}
						className="service-card-icon-img"
					/>
				</div>
				<h4 className={`h4-bold service-card-name`}>{data["name"]}</h4>
			</div>
			<h5 className="service-card-description">{data["description"]}</h5>
			<div className="service-card-button">
				{buttonMore && (
					<ButtonDesign
						data={{
							text: data["buttonMore"],
							icon: true,
							dynamic: false,
						}}
					/>
				)}
			</div>
		</div>
	);
};

export default ServiceCard;
